export default __webpack_public_path__ + "static/media/slideshow_2.4b373cb7.jpg";